import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M6.666 10.666 10 8 6.666 5.334v2H2v1.333h4.666z" }, null, -1),
    _createElementVNode("path", { d: "M8 2a5.96 5.96 0 0 0-4.242 1.758L4.7 4.7A4.64 4.64 0 0 1 8 3.333c1.247 0 2.418.486 3.3 1.367A4.64 4.64 0 0 1 12.667 8a4.64 4.64 0 0 1-1.367 3.3A4.64 4.64 0 0 1 8 12.667 4.64 4.64 0 0 1 4.7 11.3l-.942.942A5.96 5.96 0 0 0 8 14c1.603 0 3.11-.625 4.242-1.758A5.96 5.96 0 0 0 14 8c0-1.603-.625-3.11-1.758-4.242A5.96 5.96 0 0 0 8 2" }, null, -1)
  ]))]))
}
export default { render: render }